module.exports = __webpack_public_path__ + "static/img/126_TO8_1674_og.e671e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/126_TO8_1674_og.jpg
// module id = MIA7
// module chunks = 0